var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{ref:"editor",attrs:{"counter":_vm.meta.counter,"rows":"15"},on:{"input":_vm.onUpdate},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }